import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  openInviteModal;
  invitationModal = {};

  private financialReportBalanceSheetCurrentYearSource = new BehaviorSubject([]);
  financialReportBalanceSheetCurrentYearData = this.financialReportBalanceSheetCurrentYearSource.asObservable();

  // Last Year Balance Sheet
  private financialReportBalanceSheetLastYearSource = new BehaviorSubject([]);
  financialReportBalanceSheetLastYearData = this.financialReportBalanceSheetLastYearSource.asObservable();

  // Last 2 Year Balance Sheet
  private financialReportBalanceSheetLast2YearSource = new BehaviorSubject([]);
  financialReportBalanceSheetLast2YearData = this.financialReportBalanceSheetLast2YearSource.asObservable();

  // Current Year Profit And Loss
  private financialReportProfitAndLossCurrentYearSource = new BehaviorSubject([]);
  financialReportProfitAndLossCurrentYearData = this.financialReportProfitAndLossCurrentYearSource.asObservable();

  // Last Year Profit And Loss
  private financialReportProfitAndLossLastYearSource = new BehaviorSubject([]);
  financialReportProfitAndLossLastYearData = this.financialReportProfitAndLossLastYearSource.asObservable();

  // Last 2 Year Profit And Loss
  private financialReportProfitAndLossLast2YearSource = new BehaviorSubject([]);
  financialReportProfitAndLossLast2YearData = this.financialReportProfitAndLossLast2YearSource.asObservable();

  private applicationSource = new BehaviorSubject([]);
    applicationDetails = this.applicationSource.asObservable();



  constructor() { }


  // Current Year Balance Sheet
  updataFinancialReportBalanceSheetCurrentYear(arrayData) {
    this.financialReportBalanceSheetCurrentYearSource.next(arrayData)
  }

  // Last Year Balance Sheet
  updataFinancialReportBalanceSheetLastYear(arrayData) {
    this.financialReportBalanceSheetLastYearSource.next(arrayData)
  }

  // Last 2 Year Balance Sheet
  updataFinancialReportBalanceSheetLast2Year(arrayData) {
    this.financialReportBalanceSheetLast2YearSource.next(arrayData)
  }

  // Current Year Profit And Loss
  updataFinancialReportProfitAndLossCurrentYear(arrayData) {
    this.financialReportProfitAndLossCurrentYearSource.next(arrayData)
  }

  // Last Year Profit And Loss
  updataFinancialReportProfitAndLossLastYear(arrayData) {
    this.financialReportProfitAndLossLastYearSource.next(arrayData)
  }

  // Last 2 Year Profit And Loss
  updataFinancialReportProfitAndLossLast2Year(arrayData) {
    this.financialReportProfitAndLossLast2YearSource.next(arrayData)
  }

  addNewApplication(val) {
    // let previous = this.applicationSource.value
    // previous = previous.splice(previous.findIndex(a => a['id'] == val['id']), 1)
    if (val['id'] != undefined && val['id'] != '' && val['id'] != null) {
        this.applicationSource.next(this.applicationSource.value.concat([val]))
    }
}

}
